module.exports = __webpack_public_path__ + "static/media/1.2_preview.b46639df.png";